import { ErrorMessage, Field, useFormikContext } from 'formik';
import React, { useEffect } from 'react';
import { calcularIdade } from '../helpers/funcoesAuxiliares';

export const IdadeDependente = props => {
    const {
        values: { Nascimento },
        setFieldValue
    } = useFormikContext();

    useEffect(() => {
        if (Nascimento) {
            const idadeCalculada = calcularIdade(Nascimento);

            setFieldValue('Idade', idadeCalculada);
        } else {
            setFieldValue('Idade', '');
        }
    }, [Nascimento]);

    return (
        <div className="p-col-12 p-md-3">
            <div className="p-inputgroup">
                <div
                    className="p-inputgroup-addon"
                    style={{
                        backgroundColor: '#E1E1E1',
                        borderColor: 'gray',
                        color: 'gray',
                        width: '70px'
                    }}>
                    Idade
                </div>
                <Field
                    style={{
                        width: '90%'
                    }}
                    disabled={Nascimento ? true : false}
                    as="input"
                    className="input-idade"
                    type="number"
                    min="0"
                    name="Idade"
                    onBlur={props.handleBlur}
                />
            </div>
            <ErrorMessage component="span" name="Idade" style={{ color: 'red' }} />
        </div>
    );
};
